module.exports = {
    configuration_upload_mode_title: "Configure Upload Mode",
    configuration_upload_mode_all_events: "All Events",
    configuration_upload_mode_group_events: "Group of Events",
    configuration_upload_mode_specific_events: "Specific Events",
    configuration_upload_mode_all_accel_events: "All Acceleration Events",
    configuration_upload_mode_all_dms_events: "All DMS Events",
    configuration_upload_mode_all_adas_events: "All ADAS Events",
    configuration_upload_mode_all_nav_events: "All Nav Events",
    configuration_upload_mode_events: "Events",
    configuration_upload_mode_accel_events: "Acceleration Events",
    configuration_upload_mode_dms_events: "DMS Events",
    configuration_upload_mode_adas_events: "ADAS Events",
    configuration_upload_mode_others_events: "Others Events",
    configuration_upload_mode_clip: "Clip",
    configuration_upload_mode_picture: "Picture",

    configuration_upload_mode_severe_brake: "Severe Brake",
    configuration_upload_mode_hard_brake: "Hard Brake",
    configuration_upload_mode_harsh_brake: "Harsh Brake",
    configuration_upload_mode_harsh_accel: "Harsh Accel",
    configuration_upload_mode_harsh_turn: "Harsh Turn",
    configuration_upload_mode_sharp_turn: "Sharp Turn",
    configuration_upload_mode_severe_turn: "Severe Turn",
    configuration_upload_mode_driving_hit: "Driving Hit",
    configuration_upload_mode_severe_accel: "Severe Accel",
    configuration_upload_mode_driving_heavy_hit: "Driving Heavy Hit",
    configuration_upload_mode_hard_accel: "Hard Accel",

    configuration_upload_mode_using_phone: "Using Phone",
    configuration_upload_mode_smoking: "Smoking",
    configuration_upload_mode_drowsiness: "Drowsiness",
    configuration_upload_mode_no_seatbelt: "No Seatbelt",
    configuration_upload_mode_no_driver: "No Driver",
    configuration_upload_mode_daydreaming: "Daydreaming",
    configuration_upload_mode_yawn: "Yawn",
    configuration_upload_mode_asleep: "Asleep",
    configuration_upload_mode_distracted: "Distracted",

    configuration_upload_mode_forward_collision_warning: "Forward Collision Warning",
    configuration_upload_mode_headway_monitoring_warning: "Headway Monitoring Warning",
    configuration_upload_mode_headway_monitoring_emergency: "Headway Monitoring Emergency",
    configuration_upload_mode_lane_departure_warning: "Lane Departure Warning",

    configuration_upload_mode_manual: "Manual",

    configuration_upload_mode_save_title: "Save configuration upload mode",
    configuration_upload_mode_save_success: "Configuration upload mode saved",
    configuration_upload_mode_save_error: "Configuration upload mode save error",

    configuration_upload_mode_next: "Next",
    configuration_upload_mode_back: "Back",
    configuration_upload_mode_apply: "Apply",
    configuration_upload_mode_potential_incident_low: "Potential Incident Low",
    configuration_upload_mode_potential_incident_medium: "Potential Incident Medium",
    configuration_upload_mode_potential_incident_high: "Potential Incident High",
    configuration_upload_mode_driving_suspicious_hit: "Driving Suspicious Hit",
    configuration_upload_mode_idle_no_driver: "Idle No Driver",
    configuration_upload_mode_power_lost: "Power Lost",
    configuration_upload_mode_none: "None",
    configuration_upload_mode_parking_motion: "Parking Motion",
    configuration_upload_mode_parking_hit: "Parking Hit",
    configuration_upload_mode_parking_heavy_hit: "Parking Heavy Hit",
    configuration_upload_mode_driving_hit: "Driving Hit",
    configuration_upload_mode_stop_sign_violation: "Stop Sign Violation",
    configuration_upload_mode_pedestrian_collision: "Pedestrian Collision",
    configuration_upload_mode_cyclist_collision: "Cyclist Collision",

    configuration_upload_mode_nav: "Nav Events",
    configuration_upload_mode_speeding: "Speeding",
    configuration_upload_mode_over_max_speed: "Over Max Speed",

}